
import { TemporaryDocument } from "@platform-ui/@types/document.js";
import DocumentItem from "../DocumentItem/index.js";

export default function DocumentList({ documents }: { documents: TemporaryDocument[] }) {
    return (
      <div className="flex flex-col gap-5">
        {documents.map((document, index) => (
          <div
            key={document.url}
          >
            <DocumentItem
              document={document}
              key={document.url}
              {...document}
              index={index.toString()}
            />
          </div>
        ))}
      </div>
    );
  }